/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNewAuthTokenRequest } from '../../models/get-new-auth-token-request';
import { GetNewAuthTokenResponse } from '../../models/get-new-auth-token-response';

export interface GetNewAuthToken$Params {
      body: GetNewAuthTokenRequest
}

export function getNewAuthToken(http: HttpClient, rootUrl: string, params: GetNewAuthToken$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNewAuthTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, getNewAuthToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNewAuthTokenResponse>;
    })
  );
}

getNewAuthToken.PATH = '/management/v0/auth/refresh';
